import { render, staticRenderFns } from "./ScoutLiked.vue?vue&type=template&id=2126e641"
import script from "./ScoutLiked.vue?vue&type=script&lang=js"
export * from "./ScoutLiked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports